module.exports = __webpack_public_path__ + "static/media/notes-medical.a830004c.svg";